import { createSlice } from '@reduxjs/toolkit'

import { baseModelState, updateExtraReducers, openForm, closeForm } from 'store/common'
import api from './api'


const initialState = {
  ...baseModelState,
}


export const parkingCard = createSlice({
  name: 'parkingCard',
  initialState,
  reducers: {
    openForm,
    closeForm,
  },
  extraReducers: (builder) => {
    updateExtraReducers(builder, api.endpoints.updateParkingCard);
  },
});

export default parkingCard.reducer;

export const ParkingCardActions = parkingCard.actions;

